import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  private baseUrl = `${environment.Server_URL}/wallets`;

  constructor(private http: HttpClient) { }

  getUserWallet(userId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${userId}`);
  }
  useWalletBalance(user_id: number, order_id: number, amount: number): Observable<any> {
    const payload = { user_id, order_id, amount };
    return this.http.post(`${environment.Server_URL}/wallets/use`, payload);
  }
getUserTransactions(userId: number): Observable<any> {
  return this.http.get(`${this.baseUrl}/user/${userId}/transactions`);
}
}
